import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';

interface DefaultAvatarProps extends Omit<AvatarProps, 'children'> {
  name?: string;
  email?: string;
  size?: number;
}

const DefaultAvatar: React.FC<DefaultAvatarProps> = ({ 
  name, 
  email, 
  size = 40, 
  sx, 
  ...props 
}) => {
  // Generate initials from name or email
  const getInitials = () => {
    if (name) {
      const nameParts = name.trim().split(' ');
      if (nameParts.length >= 2) {
        return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
      }
      return nameParts[0][0].toUpperCase();
    }
    
    if (email) {
      const emailName = email.split('@')[0];
      return emailName.substring(0, 2).toUpperCase();
    }
    
    return 'U';
  };

  // Generate a consistent color based on name/email
  const getAvatarColor = () => {
    const text = name || email || 'user';
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Generate a color from the hash
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 50%)`;
  };

  const initials = getInitials();
  const backgroundColor = getAvatarColor();

  return (
    <Avatar
      {...props}
      sx={{
        width: size,
        height: size,
        backgroundColor,
        color: 'white',
        fontWeight: 'bold',
        fontSize: size * 0.4,
        ...sx,
      }}
    >
      {initials}
    </Avatar>
  );
};

export default DefaultAvatar;
